import _styled from "styled-components";
import type { SanityPageBuilderMarketoEmbedFormSection, SanityPageBuilderSection } from "@ouster/shared";
import { Asset, type Props as AssetProps } from "~/features/craft/asset";
import { MarketoEmbedFormBlockView, type MarketoEmbedFormBlockViewProps } from "~/features/blocks/inventory/marketo-embed-form";
import { toCraftAsset } from "~/features/sanity/media";
import { hasRenderableSanityMedia } from "~/features/sanity/page-builder/sections/media-figure";
import { SanityRichText } from "~/features/sanity/rich-text";
import { toHtml } from "~/features/sanity/rich-text/to-html";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderMarketoEmbedFormSection;
  };
};
export function SanityMarketoEmbedFormSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const successMessageDescription: MarketoEmbedFormBlockViewProps["successMessageDescription"] = sectionContent.successMessageDescription?.length ? <_StyledSanityRichText value={sectionContent.successMessageDescription} /> : undefined;
  const successMessageImage: MarketoEmbedFormBlockViewProps["successMessageImage"] = hasRenderableSanityMedia(sectionContent.successMessageImage) ? <Asset asset={toCraftAsset(sectionContent.successMessageImage) as AssetProps["asset"]} imageProps={{
    width: 800,
    sizes: "lg:50vw"
  }} /> : undefined;
  return <MarketoEmbedFormBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} customCss={toHtml(sectionContent.customCss)} description={sectionContent.description} fullWidth={sectionContent.fullWidth} hasRedirect={sectionContent.hasRedirect} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} marketoFormId={sectionContent.marketoFormId} marketoFormInstanceId={sectionContent.marketoFormInstanceId} marketoFormUrl={sectionContent.marketoFormUrl} mode={sectionSettings?.mode || "light"} redirectUrl={sectionContent.redirectUrl} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} successMessageDescription={successMessageDescription} successMessageImage={successMessageImage} successMessageTitle={sectionContent.successMessageTitle} />;
}
var _StyledSanityRichText = /*#__PURE__*/_styled(SanityRichText).withConfig({
  displayName: "marketo-embed-form___StyledSanityRichText",
  componentId: "sc-1nd7jcf-0"
})({
  "marginBottom": "4rem",
  "marginTop": "2.4rem"
});